import {z} from "zod";

export const inquiryStatusSchema = z.enum(["open", "accepted", "declined"]);

export const inquiryStatusSchemaTranslation = {
  "open": "Offen",
  "accepted": "Akzeptiert",
  "declined": "Abgelehnt"
}

export type InquiryStatus = z.infer<typeof inquiryStatusSchema>;

export const inquirySchema = z.object({
  id: z.string(),
  appId: z.string().max(10),
  functionType: z.string().min(3),
  name: z.string().min(3),
  message: z.string().min(3),
  status: inquiryStatusSchema.default(inquiryStatusSchema.enum.open),
  updatedAt: z.number(),
  updatedBy: z.string(),
  createdAt: z.number(),
  createdBy: z.string(),
})
export type Inquiry = z.infer<typeof inquirySchema>;

export const inquiryCreateRequestSchema = inquirySchema.pick({functionType: true, name: true, message: true});
export type InquiryCreateRequest = z.infer<typeof inquiryCreateRequestSchema>;

export const inquiryUpdateStatusRequestSchema = inquirySchema.pick({id: true, status: true});
export type InquiryUpdateStatusRequest = z.infer<typeof inquiryUpdateStatusRequestSchema>;

export const inquiryGetQuerySchema = inquirySchema.pick({id: true});
export type InquiryGetQuery = z.infer<typeof inquiryGetQuerySchema>;
